import { render } from "./UnreadEvents.vue?vue&type=template&id=74e718c1&scoped=true"
import script from "./UnreadEvents.vue?vue&type=script&lang=js"
export * from "./UnreadEvents.vue?vue&type=script&lang=js"

import "./UnreadEvents.vue?vue&type=style&index=0&id=74e718c1&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e718c1"]])

export default __exports__